import { BankSetupSuccessContainer } from 'src/containers';

export const BankSetupSuccess = () => <BankSetupSuccessContainer />;
